import api from '../api'

const state = {
  poiList: [],
  tourList: []
}

const getters = {
  getTour: (state) => (id) => {
    return state.tourList.find(tour => tour.id === id)
  }
}

const mutations = {
  setPOIs (state, poiList) {
    state.poiList = poiList
  },
  setTours (state, tours) {
    state.tourList = tours
  }
}

const actions = {
  getPOIs ({ rootState, rootGetters, commit }, options) {
    return new Promise((resolve, reject) => {
      const position = rootGetters.getUserPosition
      if (position) {
        api.getClosestPOIs(
          rootState.college.id,
          position.lat,
          position.lon,
          options
        ).then((response) => {
          commit('setPOIs', response.data)
          resolve(response.data)
        })
      } else {
        api.getPOIs(rootState.college.id, options).then(response => {
          commit('setPOIs', response.data)
          resolve(response.data)
        })
      }
    })
  },
  getTours ({ rootState, commit }) {
    return new Promise((resolve, reject) => {
      api.getTours(rootState.college.id).then(response => {
        commit('setTours', response.data)
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
